import { render, staticRenderFns } from "./Get_events.vue?vue&type=template&id=732add49&scoped=true"
import script from "./Get_events.vue?vue&type=script&lang=js"
export * from "./Get_events.vue?vue&type=script&lang=js"
import style0 from "./Get_events.vue?vue&type=style&index=0&id=732add49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732add49",
  null
  
)

export default component.exports